@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/inputs' as *;

:host {
  display: block;
  position: relative;
  @include default-css-variables;
  width: 100%;

  @media #{$mobile} {
    position: unset;
  }
}

label {
  @include input-label;
  flex-direction: column;
  gap: 4px;
  font-family: var(--nylas-font-family);
  font-size: 16px;
  color: var(--nylas-base-800);

  p {
    margin: 0;
  }

  .error {
    color: var(--nylas-error);
  }
}

.dropdown {
  display: inline-block;
  width: inherit;
}

.dropbtn {
  color: var(--nylas-base-800);
  padding: 14px;
  font-size: 16px;
  font-family: var(--nylas-font-family);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  background: var(--nylas-base-0);
  border: 1px solid var(--nylas-base-300);
  border-radius: var(--nylas-border-radius-2x);

  &.error {
    border: 1px solid var(--nylas-error);
  }

  &:hover,
  &:active {
    outline: 1px solid var(--nylas-primary);
  }

  &:active {
    outline: 2px solid var(--nylas-primary);
  }

  &:disabled {
    cursor: not-allowed;
    background: var(--nylas-base-100);
  }

  span {
    &.chevron {
      display: flex;
      align-self: center;
    }

    &.open {
      transform: rotate(90deg);
    }

    &.closed {
      transform: rotate(270deg);
    }

    &.selected-option {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 144px;
      font-size: 14px;
      line-height: 20px;
      color: inherit;

      @media #{$mobile} {
        max-width: 124px;
        font-size: 16px;
      }
    }
  }
}

.dropdown-content {
  display: block;
  margin-top: 0.5rem;
  background-color: var(--nylas-base-0);
  width: 100%;
  max-height: 336px;
  overflow: auto;
  z-index: 1;
  border-radius: 4px;
  position: absolute;
  box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);

  // Firefox scrollbar styling
  scrollbar-width: thin;
  scrollbar-color: var(--nylas-base-300) var(--nylas-base-50);

  // Custom scrollbar styling
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: var(--nylas-base-50);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--nylas-base-300);
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
      background: var(--nylas-base-400);
    }
  }

  &::-webkit-scrollbar-thumb:active {
    background: var(--nylas-base-500);
  }

  @media #{$mobile} {
    right: 0;
    width: 325px;
    max-width: unset;
  }
}

.search-box {
  border-bottom: 1px solid var(--nylas-base-200);
  padding: 10px;
  position: sticky;
  top: 0;
  background: var(--nylas-base-0);

  .icon {
    position: absolute;
    top: 1.25rem;
    left: 1.25rem;
    color: var(--nylas-base-300);
  }
}

.dropdown-content ul {
  padding: 0;
  list-style-type: none;
  color: var(--nylas-base-900);
  max-height: 336px;

  li {
    padding: 16px, 12px, 16px, 12px;
    color: var(--nylas-base-900);
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    font-family: inherit;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    cursor: pointer;

    &:hover,
    &:focus {
      background-color: var(--nylas-base-100);
    }
  }
}

.dropdown-content .selected {
  background-color: #e7e7e7;
}

input[type='text'] {
  width: -webkit-fill-available;
  padding: inherit;
  border: 1px solid var(--nylas-base-200);
  border-radius: 4px;
  position: sticky;
  background: no-repeat scroll 7px 7px;
  padding-left: 30px;
  background-size: 16px 16px;
  color: var(--nylas-base-800);
}
